import Player from '@vimeo/player';
const Modal = (()=>{

    const ConfigModal = ()=>{
        const btnOpenVideo = document.querySelectorAll('.open-modal');
        const btnCloseVideo = document.querySelectorAll('.close-modal');
        const getCtnVideo = document.querySelector('.modal-video');

        //ABRIMOS EL MODAL Y REPRODUCIMOS EL VIDEO
        btnOpenVideo.forEach((data)=>{
            data.addEventListener('click', ()=>{
                getCtnVideo.classList.add('active');
                const player = new Player(document.querySelector('.modal-video iframe'))
                setTimeout(() => {
                    player.play()
                }, 100);
            });
        });

        //CERRAMOS EL MODAL Y PAUSAMOS EL VIDEO
        btnCloseVideo.forEach((data)=>{
            data.addEventListener('click', ()=>{
                getCtnVideo.classList.remove('active');
                const player = new Player(document.querySelector('.modal-video iframe'))
                setTimeout(() => {
                    player.unload()
                }, 100);
            });
        });

    }


    return {
        ChildsModal : function(){
            try{ConfigModal();}catch(err){  }
        }
    }

})();

const getChildsModal = ()=>{
    Modal.ChildsModal();
}

export { getChildsModal }